module.exports = "/_next/static/images/teaser1-slice-2-d91818315249ee3832a28807cb9bfbc6.jpg";